import { form } from "../../../shared/src/codecs/types/form";
import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { required } from "../../../shared/src/codecs/types/required";
import { array } from "../../../shared/src/codecs/types/array";
import { string } from "../../../shared/src/codecs/types/string";
import { boolean } from "../../../shared/src/codecs/types/boolean";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { CaseId } from "../CaseId";
import { EmptyObject } from "../EmptyObject";
import { CasesEpcWhoArranges } from "../CasesEpc";

export const EpcSearchResult = required({
    certificate_number: string(),
    address: string(),
    postcode: string(),
    rating: string(),
    registration_date: string(),
    uprn: string(),
});
export type TEpcSearchResultCodec = typeof EpcSearchResult;
export type TEpcSearchResult = TTypeOfCodec<TEpcSearchResultCodec>;

export const CaseEpcSearchForm = form(
    required({ case_id: uuid(), search_term: string() }),
    required({ results: array(EpcSearchResult) }),
);
export type TCaseEpcSearchFormCodec = typeof CaseEpcSearchForm;
export type TCaseEpcSearchForm = TTypeOfCodec<TCaseEpcSearchFormCodec>;

export const CaseEpcAttachForm = form(
    required({
        case_id: uuid(),
        certificate_number: string(),
        address: string(),
        postcode: string(),
        rating: string(),
        registration_date: string(),
        uprn: string(),
    }),
    EmptyObject,
);
export type TCaseEpcAttachFormCodec = typeof CaseEpcAttachForm;
export type TCaseEpcAttachForm = TTypeOfCodec<TCaseEpcAttachFormCodec>;

export const CaseEpcRerunLookupForm = form(CaseId, EmptyObject);
export type TCaseEpcRerunLookupFormCodec = typeof CaseEpcRerunLookupForm;
export type TCaseEpcRerunLookupForm = TTypeOfCodec<TCaseEpcRerunLookupFormCodec>;

export const CaseEpcMarkNotRequiredForm = form(CaseId, EmptyObject);
export type TCaseEpcMarkNotRequiredFormCodec = typeof CaseEpcMarkNotRequiredForm;
export type TCaseEpcMarkNotRequiredForm = TTypeOfCodec<TCaseEpcMarkNotRequiredFormCodec>;

export const CaseEpcSetSortedForm = form(
    required({ case_id: uuid(), new_epc_sorted: boolean() }),
    EmptyObject,
);
export type TCaseEpcSetSortedFormCodec = typeof CaseEpcSetSortedForm;
export type TCaseEpcSetSortedForm = TTypeOfCodec<TCaseEpcSetSortedFormCodec>;

export const ClientCaseEpcWhoArrangesForm = form(
    required({ case_id: uuid(), who_arranges_new_epc: CasesEpcWhoArranges }),
    EmptyObject,
);
export type TClientCaseEpcWhoArrangesFormCodec = typeof ClientCaseEpcWhoArrangesForm;
export type TClientCaseEpcWhoArrangesForm = TTypeOfCodec<TClientCaseEpcWhoArrangesFormCodec>;
